export enum BridgeEvent {
	cartUpdated = 'cartUpdated',
	gigyaAccountInfoReceived = 'gigyaAccountInfoReceived',
	scanToTrolley = 'scanToTrolley',
	googlePayInitialized = 'googlePayInitialized',
	googlePayClicked = 'googlePayClicked',
}
